export default "__VITE_ASSET__b3d2765c__"